/* NOUN — przejscie przez przyslone miedzy stronami.
   =================================================

   Do tej pory kliknieta gwiazda otwierala warstwe NAD strona glowna: adres
   konczyl sie na #/dresses, wiec nie dalo sie wyslac komus odnosnika do
   sukienek, a wyszukiwarki nie widzialy tej listy w ogole. Prawdziwe strony
   kategorii istnialy obok, nieodwiedzane. Teraz gwiazda prowadzi na
   prawdziwy adres, a przyslona jest tym, co dzieje sie po drodze.

   Ruch jest ten sam, co przy zejsciu do Genesis: dziura zamyka sie nad
   strona, ktora opuszczasz, i otwiera na tej, do ktorej wchodzisz. Zaslona
   jest czarna, a otwor wyciety w niej maska --- promien jednej krzywej,
   dwa kierunki.

   Pierscienie sa rysowane tanszym szumem niz te w portalu nr 2: cztery
   oktawy Perlina co klatke maja sens, kiedy patrzy sie na nie przez pol
   minuty schodzenia, a nie przez pol sekundy przejscia. Suma dwoch sinusow
   daje ten sam charakter przy dziesiatej czesci kosztu --- to jest swiadomy
   kompromis na rzecz telefonu, nie niedopatrzenie.

   Zaslona pojawia sie tylko tam, gdzie wczesniej zamknela sie inna: znacznik
   w sessionStorage stawia strona, ktora opuszczasz. Wejscie z zewnatrz, z
   zakladki albo z wyszukiwarki nie kaze nikomu ogladac animacji, na ktora
   nie prosil. Przy wylaczonych animacjach w systemie nie ma jej wcale. */
(() => {
'use strict';

const KEY = 'noun:gate';
const store = {
  set(){ try{ sessionStorage.setItem(KEY, '1'); }catch(e){} },
  take(){ try{ const v = sessionStorage.getItem(KEY); sessionStorage.removeItem(KEY); return v; }catch(e){ return null; } }
};

const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
const MOB = innerWidth < 760;

/* --- zaslona ---------------------------------------------------------- */
let veil = null, cv = null, cx2 = null, W = 0, H = 0, DPR = 1;

function mkVeil(){
  if(veil) return;
  const st = document.createElement('style');
  st.textContent =
    '#noun-gate{position:fixed;inset:0;z-index:9000;background:#000;pointer-events:none;' +
    '-webkit-mask-image:radial-gradient(circle var(--gr,0px) at var(--gx,50%) var(--gy,50%),' +
    'rgba(0,0,0,0) 98%,#000 100%);' +
    'mask-image:radial-gradient(circle var(--gr,0px) at var(--gx,50%) var(--gy,50%),' +
    'rgba(0,0,0,0) 98%,#000 100%)}' +
    '#noun-gate canvas{position:absolute;inset:0;width:100%;height:100%}';
  document.head.appendChild(st);

  veil = document.createElement('div');
  veil.id = 'noun-gate';
  veil.setAttribute('aria-hidden','true');
  cv = document.createElement('canvas');
  veil.appendChild(cv);
  (document.body || document.documentElement).appendChild(veil);
  cx2 = cv.getContext('2d');
  fit();
  addEventListener('resize', fit, {passive:true});
}
function fit(){
  if(!cv) return;
  DPR = Math.min(devicePixelRatio || 1, 2);
  W = innerWidth; H = innerHeight;
  cv.width = Math.floor(W*DPR); cv.height = Math.floor(H*DPR);
  cx2.setTransform(DPR,0,0,DPR,0,0);
}

/* --- pierscienie ------------------------------------------------------ */
const NR = MOB ? 16 : 24;
const seed = Math.random()*6.2832;

function rings(hole, alpha, gx, gy, t){
  if(!cx2) return;
  cx2.clearRect(0,0,W,H);
  if(alpha <= .004) return;
  const R = Math.hypot(Math.max(gx, W-gx), Math.max(gy, H-gy));
  const step = Math.max(1, (R - hole) / NR);
  const amp = Math.min(46, R*0.055);
  const STEP = MOB ? 9 : 6;
  cx2.save();
  cx2.translate(gx, gy);
  cx2.lineWidth = 1;
  for(let i=0;i<NR;i++){
    const fade = 1 - Math.pow(i/NR, 2.0)*0.78;
    const a = fade * 0.5 * alpha;
    if(a <= .004) continue;
    cx2.strokeStyle = 'rgba(237,234,228,' + a.toFixed(3) + ')';
    cx2.beginPath();
    for(let d=0; d<=360; d+=STEP){
      const rad = d*Math.PI/180;
      const w = Math.sin(rad*3 + i*0.72 + seed + t*0.9)*amp
              + Math.sin(rad*5 - i*0.41 + seed*1.7 - t*0.6)*amp*0.45;
      const rr = hole + step*i + w;
      const x = rr*Math.cos(rad), y = rr*Math.sin(rad);
      d ? cx2.lineTo(x,y) : cx2.moveTo(x,y);
    }
    cx2.closePath(); cx2.stroke();
  }
  cx2.restore();
}

/* --- ruch ------------------------------------------------------------- */
const ease = p => p<.5 ? 4*p*p*p : 1-Math.pow(-2*p+2,3)/2;

function run(from, to, ms, gx, gy, done){
  mkVeil();
  veil.style.setProperty('--gx', gx.toFixed(0)+'px');
  veil.style.setProperty('--gy', gy.toFixed(0)+'px');
  const full = Math.hypot(Math.max(gx, W-gx), Math.max(gy, H-gy)) * 1.02;
  const t0 = performance.now();
  (function step(now){
    const p = Math.min(1, (now - t0)/ms), e = ease(p);
    const r = (from + (to-from)*e) * full;
    veil.style.setProperty('--gr', r.toFixed(1)+'px');
    /* pierscienie towarzysza krawedzi otworu i gasna, kiedy ten dochodzi
       do rogu ekranu --- wtedy nie ma juz czego obrysowywac */
    rings(r, Math.min(1, 1.35*(1 - r/full)), gx, gy, (now-t0)/1000);
    if(p < 1) requestAnimationFrame(step);
    else if(done) done();
  })(t0);
}

/* --- wejscie ---------------------------------------------------------- */
/* Zaslona musi byc czarna, zanim cokolwiek zostanie namalowane, inaczej
   widac blysk strony przed jej zamknieciem. Dlatego ten plik jest wolany
   synchronicznie, a nie z opoznieniem. */
if(!reduce && store.take()){
  mkVeil();
  veil.style.setProperty('--gr','0px');
  const open = () => run(0, 1, 780, W/2, H/2, () => { veil.remove(); veil = null; });
  if(document.readyState === 'loading') addEventListener('DOMContentLoaded', open, {once:true});
  else open();
}

/* Powrot przyciskiem wstecz z pamieci przegladarki: strona wraca w stanie,
   w jakim ja zostawiono --- lacznie z zaslona zamknieta na czarno. */
addEventListener('pageshow', e => {
  if(e.persisted && veil){ veil.remove(); veil = null; }
});

/* --- wyjscie ---------------------------------------------------------- */
function leave(href, gx, gy){
  if(reduce){ location.href = href; return; }
  store.set();
  run(1, 0, 620, gx, gy, () => { location.href = href; });
  /* gdyby przegladarka zdusila animacje (karta w tle, oszczedzanie energii),
     przejscie i tak nastepuje --- nikt nie ma utknac na czarnym ekranie */
  setTimeout(() => { if(location.href !== href) location.href = href; }, 1100);
}

/* Karuzela ma wlasna obsluge wskaznika w sekcji strony glownej, bo scena
   przechwytuje wskaznik i klikniecie tam nie dochodzi. Tamten kod wchodzil
   na strone sztuki twardym location.href, czyli omijal przyslone: gwiazdy
   przechodzily przez portal, a karuzela skakala. Jedno wyjscie na zewnatrz
   zszywa oba przejscia w jedno. Kto go nie zastanie, przejdzie po staremu. */
window.nounGate = function(href, gx, gy){
  leave(href,
        typeof gx === 'number' ? gx : innerWidth / 2,
        typeof gy === 'number' ? gy : innerHeight / 2);
};

function plain(e, a){
  return a && a.href && !e.defaultPrevented && e.button === 0 &&
    !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey &&
    a.target !== '_blank' && !a.hasAttribute('download') &&
    a.origin === location.origin && !a.getAttribute('href').startsWith('#');
}

/* Karuzela przechwytuje wskaznik na scenie (setPointerCapture), zeby dalo sie
   ciagnac ja poza jej obrys. Skutek uboczny jest taki, ze przegladarka
   PRZEADRESOWUJE pozniejsze klikniecie na element przechwytujacy: e.target to
   zawsze #orbStage, nigdy zdjecie ani odnosnik pod nim. Dlatego zadne
   klikniecie w karuzeli nie dochodzilo tam, gdzie mialo --- ani "Enter",
   ani obrot na kartach z boku. Zmierzone: cel klikniecia to DIV.orbit__stage.

   Nie odbieram karuzeli przechwytu, bo ciagniecie ma dzialac. Zamiast tego
   pytam o element pod kursorem wprost, wspolrzednymi. */
let synth = false;
let downX = 0, downY = 0;

addEventListener('pointerdown', e => { downX = e.clientX; downY = e.clientY; }, true);

addEventListener('click', e => {
  if(synth) return;                       // nasze wlasne, przekazane dalej
  /* ciagniecie nie jest klikinieciem: osiem pikseli luzu na drzenie reki */
  if(Math.hypot(e.clientX - downX, e.clientY - downY) > 8) return;

  const hit = document.elementFromPoint(e.clientX, e.clientY) || e.target;
  if(!hit || !hit.closest) return;

  const a = hit.closest('a.star, a.orb__enter, a.col__card');
  if(a && plain(e, a)){
    e.preventDefault(); e.stopPropagation();
    const r = a.getBoundingClientRect();
    leave(a.href, r.left + r.width/2, r.top + r.height/2);
    return;
  }

  const card = hit.closest('.orb');
  if(!card) return;

  /* Karta stojaca w osi: cale zdjecie prowadzi do sztuki, a nie tylko slowo
     "Enter" pod nim. */
  if(card.classList.contains('is-focus')){
    const link = card.querySelector('a.orb__enter');
    if(link && link.origin === location.origin && e.button === 0 &&
       !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey){
      e.preventDefault(); e.stopPropagation();
      const r = card.getBoundingClientRect();
      leave(link.href, r.left + r.width/2, r.top + r.height/2);
    }
    return;
  }

  /* Karta z boku ma tylko obrocic karuzele --- ale jej wlasna obsluga nigdy
     nie dostawala klikniecia z tego samego powodu. Podajemy je jej wprost. */
  synth = true;
  try{
    card.dispatchEvent(new MouseEvent('click', {
      bubbles:true, cancelable:true, button:0,
      clientX:e.clientX, clientY:e.clientY
    }));
  } finally { synth = false; }
}, true);
})();
